import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=e220e12c&scoped=true&"
import script from "./LazyImage.vue?vue&type=script&lang=ts&"
export * from "./LazyImage.vue?vue&type=script&lang=ts&"
import style0 from "./LazyImage.vue?vue&type=style&index=0&id=e220e12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e220e12c",
  null
  
)

export default component.exports